import { makeStyles } from '@material-ui/core/styles';
import { darkBlue } from '@signaturit/react-components-library';

export const useIdleTimerContainerStyles = makeStyles(() => ({
    body: {
        color: darkBlue,
    },
    logoutButton: {
        paddingRight: 16,
    },
}));
